import(/* webpackMode: "eager" */ "/opt/render/project/src/client/app/about/page.js");
